import { Component, OnInit } from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from 'src/app/services/login.service';
import { URI } from 'src/app/settings/uri-constants';
import { StorageConstant } from 'src/app/settings/storage-constants';

@Component({
    selector: 'app-create-password',
    templateUrl: './create-password.component.html',
    styleUrls: ['./create-password.component.css'],
})
export class CreatePasswordComponent {
    show: boolean;
    resend: boolean;
    showConfirm: boolean;
    display: boolean;
    displaySuccess: boolean;
    forgotPassword: boolean;
    errorMessage: string;
    successMessage: string;
    confirmPasswordFocused: boolean;
    passwordFocused: boolean;
    showPasswordImage: string;
    showConfirmPasswordImage: string;
    confirmPassword = '';
    newPassword = '';
    form: FormGroup;
    id: string;

    constructor(
        private router: Router,
        private formBuilder: UntypedFormBuilder,
        private route: ActivatedRoute,
        private loginService: LoginService,
    ) {
        this.show = true;
        this.showConfirm = true;
        this.forgotPassword = false;
        this.passwordFocused = false;
        this.display = false;
        this.displaySuccess = false;
        this.errorMessage = '';
        this.successMessage = '';
        this.showPasswordImage = 'show-password';
        this.showConfirmPasswordImage = 'show-password';

        this.route.paramMap.subscribe((params) => {
            this.id = params.get('id');
        });

        this.form = this.formBuilder.group({
            newPassword: [''],
            confirmPassword: [''],
        });
    }

    changePasswordDisplayType() {
        this.show = !this.show;
        this.showPasswordImage =
            this.showPasswordImage === 'show-password' ? 'show-password-active' : 'show-password';
    }

    changeConfirmPasswordDisplayType() {
        this.showConfirm = !this.showConfirm;
        this.showConfirmPasswordImage =
            this.showConfirmPasswordImage === 'show-password'
                ? 'show-password-active'
                : 'show-password';
    }

    openModel() {
        this.display = true;
    }

    openSuccessModel() {
        this.displaySuccess = true;
    }

    closeModel() {
        this.display = false;
        this.displaySuccess = false;
    }

    passwordFocusFunction() {
        this.passwordFocused = !this.passwordFocused;
    }

    confirmPasswordFocusFunction() {
        this.confirmPasswordFocused = !this.confirmPasswordFocused;
    }

    goToSignIn() {
        this.router.navigate([URI.SLASHED_LOGIN]);
    }

    resetForm() {
        this.form.get('newPassword').setValue('');
        this.form.get('confirmPassword').setValue('');
    }

    submit() {
        const pass = String(this.form.value.newPassword);
        const reg = new RegExp('^[0-9]*$');

        if (pass.length < 4) {
            this.errorMessage = 'The Password should have atleast 4 characters (numbers only).';
            this.openModel();
            return false;
        }
        if (!reg.test(pass)) {
            this.errorMessage = 'The Password should have numbers only.';
            this.openModel();
            return false;
        }
        if (this.form.value.newPassword !== this.form.value.confirmPassword) {
            this.errorMessage = 'Passwords do not match.';
            this.openModel();
            return false;
        }

        this.loginService.createPassword(this.form.value, this.id).subscribe(
            (response) => {
                if (response.success) {
                    localStorage.setItem(StorageConstant.CREATE_PASSWORD_SUCCESS, 'success');
                    this.router.navigate([URI.SLASHED_LOGIN]);
                } else {
                    this.errorMessage = response.status.message;
                    this.openModel();
                    if (response.resend) {
                        this.resend = true;
                    }
                }
            },
            (error) => {
                this.errorMessage = 'Server Unavailable';
                if (error.status === 401) {
                    this.errorMessage = 'This link has been expired.';
                }
                this.openModel();
            },
        );
    }

    resendEmail() {
        this.closeModel();
        this.resetForm();

        this.loginService.resendCreatePasswordLink(this.id).subscribe(
            (response) => {
                if (response.success) {
                    this.resend = false;
                    this.displaySuccess = true;
                    this.successMessage =
                        'New verification link generated successfully. Please check your E-Mail.';
                    this.openSuccessModel();
                } else {
                    this.errorMessage = 'Service unavailable, Please try again later';
                    this.openModel();
                }
            },
            (error) => {
                this.errorMessage = 'Service unavailable, Please try again later.';
                if (error.status === 401) {
                    this.errorMessage = 'This link has been expired.';
                }
                this.openModel();
            },
        );
    }
}
